import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="max-w-7xl mx-auto p-6 text-gray-800 leading-relaxed">
      {/* Title */}
      <h3 className="text-3xl font-bold mb-2">Terms &amp; Conditions</h3>

      {/* Intro */}
      <p className="mb-4 mt-6 text-black text-md">
        This document is an electronic record in terms of Information Technology
        Act, 2000 (India) and rules there under as applicable and the provisions
        pertaining to electronic records in various statutes as amended by the
        Information Technology Act, 2000. This electronic record is generated by
        a computer system and does not require any physical or digital
        signatures.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        Limited TYKA is a brand registered under the company TK Sports Private
        Limited.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        Your use of the TK Sports website <strong>www.tyka.com</strong>{" "}
        (hereinafter referred to as "TYKA / TK Sports / TK Sports Website /
        Website") and its services and tools are governed by the following terms
        and conditions ("Terms of Use"). If you transact on TYKA, you shall be
        subject to the policies that are applicable to the website for such
        transaction. By mere use of the website, you shall be contracting with
        TK Sports Private Limited, a company incorporated under the Companies
        Act, 1956, with its Corporate Office at 407, Leather Complex, Kapurthala
        Road, Jalandhar – 144021, Punjab, India, and these terms and conditions
        constitute your binding obligations.
        <br />
        <br />
        For the purpose of these Terms of Use, wherever the context so requires,
        "You" shall mean any natural or legal person who has agreed to become a
        member of the Website by providing Registration Data while registering
        on the Website as a Registered User using the computer systems of TK
        Sports.
        <br />
        <br />
        When you use any of the services provided by TK Sports, including but
        not limited to Customer Comments, you will be subject to the rules,
        guidelines, policies, terms, and conditions applicable to such service,
        and they shall be deemed to be incorporated into these Terms of Use and
        considered as part and parcel thereof. TK Sports reserves the right, at
        its sole discretion, to change, modify, add, or remove portions of these
        Terms of Use at any time. It is your responsibility to check the Terms
        of Use periodically for changes. Your continued use of the Site
        following the posting of changes will mean that you accept and agree to
        the changes. As long as you comply with these Terms of Use, TK Sports
        grants you a personal, non-exclusive, non-transferable, limited
        privilege to enter and use the Site.
        <br />
        <br />
        ACCESSING, BROWSING, OR OTHERWISE USING THE SITE INDICATES YOUR
        AGREEMENT TO ALL THE TERMS AND CONDITIONS IN THIS AGREEMENT, SO PLEASE
        READ THIS AGREEMENT CAREFULLY BEFORE PROCEEDING.
      </p>
      {/* Section 1 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">
        Membership Eligibility
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        Use of the TK Sports TYKA Website is available only to persons who can
        enter into a legally binding contract under the Indian Contract Act,
        1872. Persons who are "incompetent to contract" within the meaning of
        the Indian Contract Act, 1872, including minors and undischarged
        insolvents, are not eligible to use the TK Sports TYKA Website. If you
        are a minor, i.e., under the age of 18 years, you shall not register as
        a member of TYKA and shall not transact or use the TYKA website. As a
        minor, if you wish to use or transact on TK Sports, such use or
        transaction may only be made by your legal guardian or parents who have
        registered as users of TK Sports. TK Sports reserves the right to
        terminate your membership and refuse to provide you with access to TK
        Sports if it is brought to TK Sports' notice, or if it is discovered,
        that you are under the age of 18 years or otherwise incompetent to
        contract under applicable laws.
      </p>
      {/* Section 2 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">
        Your Account and Registration Obligations
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        If You use TK Sport's TYKA website, You shall be responsible for
        maintaining the confidentiality of your User ID and Password and you
        shall be responsible for all activities that occur under your User ID
        and Password. You agree that if you provide any information that is
        untrue, inaccurate, not current or incomplete or TK Sports has
        reasonable grounds to suspect that such information is untrue,
        inaccurate, not current or incomplete, or not in accordance with the
        this Terms of Use, TK Sports has the right to indefinitely suspend or
        terminate or block access of your membership with TK Sports and refuse
        to provide you with access to the Website.
      </p>

      {/* Section 3 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Communications</h3>
      <p className="mb-4 mt-6 text-black text-md">
        When You use the Website or send emails or other data, information or
        communication to TK Sports, You agree and understand that you are
        communicating with TK Sports through electronic records and you consent
        to receive communications via electronic records from TK Sports
        periodically and as and when required. TK Sports may communicate with
        you by email or by such other mode of communication, electronic or
        otherwise.
      </p>

      {/* Section 4 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Charges</h3>
      <p className="mb-4 mt-6 text-black text-md">
        Membership on the TK Sports TYKA website is free. TK Sports does not
        charge any fee for browsing and transacting on TK Sports. However, TK
        Sports reserves the right to charge fee and change its policies from
        time to time. In particular, TK Sports may at its sole discretion
        introduce new services and modify some or all of the existing services
        offered on the TK Sports website. In such an event TK Sports reserves,
        without notice to You, the right to introduce fees for the new services
        offered or amend/introduce fees for existing services, as the case may
        be. Changes to the Fee and related policies shall automatically become
        effective immediately once implemented on TK Sports. Unless otherwise
        stated, all fees shall be quoted in Indian Rupees. You shall be solely
        responsible for compliance of all applicable laws including those in
        India for making payments to TK Sports.
      </p>

      {/* Section 5 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Use of Website</h3>
      <p className="mb-4 mt-6 text-black text-md">
        You agree, undertake and confirm that your use of TK Sports shall be
        strictly governed by the following binding principles: You shall not
        host, display, upload, modify, publish, transmit, update or share any
        information that:
        <br />
        <br />
        (a) belongs to another person and to which You do not have any right to;
        or
        <br />
        (b) that is grossly harmful, harassing, blasphemous, defamatory,
        obscene, pornographic, paedophilic, libellous, invasive of another's
        privacy, hateful, or racially, ethnically objectionable, disparaging,
        relating or encouraging money laundering or gambling, or otherwise
        unlawful in any manner whatever, or unlawfully threatening or unlawfully
        harassing including but not limited to "indecent representation of
        women" within the meaning of the Indecent Representation of Women
        (Prohibition) Act, 1986; or
        <br />
        (c) misleading in any way; or
        <br />
        (d) is patently offensive to the online community, such as sexually
        explicit content, or content that promotes obscenity, pedophilia,
        racism, bigotry, hatred or physical harm of any kind against any group
        or individual; or
        <br />
        (e) harasses or advocates harassment of another person; or (f) involves
        the transmission of "junk mail," "chain letters," or unsolicited mass
        mailing or "spamming"; or
        <br />
        (g) promotes illegal activities or conduct that is abusive, threatening,
        obscene, defamatory or libelous; or (h) infringes upon or violates any
        third party's rights, (including, but not limited to, intellectual
        property rights, rights of privacy (including without limitation
        unauthorized disclosure of a person's name, email address, physical
        address or phone number) or rights of publicity]; or
        <br />
        (i) promotes an illegal or unauthorized copy of another person's
        copyrighted work (see "Copyright complaint" below for instructions on
        how to lodge a complaint about uploaded copyrighted material), such as
        providing pirated computer programs or links to them, providing
        information to circumvent manufacture-installed copy-protect devices, or
        providing pirated music or links to pirated music files; or
        <br />
        (j) contains restricted or password-only access pages, or hidden pages
        or images (those not linked to or from another accessible page); or
        <br />
        (l) provides material that exploits people in a sexual, violent or
        otherwise inappropriate manner or solicits personal information from
        anyone; or
        <br />
        (m) provides instructional information about illegal activities such as
        making or buying illegal weapons, violating someone's privacy, or
        providing or creating computer viruses; or
        <br />
        (n) contains video, photographs, or images of another person without his
        or her express written consent and permission or the permission or the
        consent of his her guardian in the case of minor; or
        <br />
        (o) tries to gain unauthorized access or exceeds the scope of authorized
        access (as defined herein and in other applicable Codes of Conduct or
        End User Access and License Agreements) to the Sites or to profiles,
        blogs, communities, account information, bulletins, friend request, or
        other areas of the Sites or solicits passwords or personal identifying
        information for commercial or unlawful purposes from other users; or
        <br />
        (p) engages in commercial activities and/or sales without TK Sport's
        prior written consent such as contests, sweepstakes, barter, advertising
        and pyramid schemes, or the buying or selling of "virtual" items related
        to the Sites. Throughout this Terms of Use, TK Sports "prior written
        consent" means a communication coming from TK Sports Legal personnel,
        specifically in response to your request, and specifically addressing
        the activity or conduct for which You seek authorisation; or
        <br />
        (q) solicits gambling or engages in any gambling activity which TK
        Sports, in its sole discretion, believes is or could be construed as
        being illegal; or
        <br />
        (r) interferes with another user's use and enjoyment of the TK Sports
        Website or any other individual's user and enjoyment of similar
        services; or
        <br />
        (s) refers to any website or URL that, in the sole discretion of TK
        Sports, contains material that is inappropriate for the TK Sports World
        Website or any other Website, contains content that would be prohibited
        or violates the letter or spirit of these Terms of Use; or
        <br />
        (t) harm minors in any way; or
        <br />
        (u) infringes any patent, trademark, copyright or other proprietary
        rights or third party's trade secrets or rights of publicity or privacy
        or shall not be fraudulent or involve the sale of counterfeit or stolen
        items; or
        <br />
        (v) violates any law for the time being in force; or
        <br />
        (w) deceives or misleads the addressee/ users about the origin of such
        messages or communicates any information which is grossly offensive or
        menacing in nature; or (x) impersonate another person; or
        <br />
        (y) contains software viruses or any other computer code, files or
        programs designed to interrupt, destroy or limit the functionality of
        any computer resource; or contains any Trojan horses, worms, time bombs,
        cancelbots, easter eggs or other computer programming routines that may
        damage, detrimentally interfere with, diminish value of, surreptitiously
        intercept or expropriate any system, data or personal identifiable
        information; or
        <br />
        (z) threatens the unity, integrity, defence, security or sovereignty of
        India, friendly relations with foreign states, or public order or causes
        incitement to the commission of any cognizable offence or prevents
        investigation of any offence or is insulting to any other nation; or
        <br />
        (aa) shall not be false, inaccurate or misleading; or
        <br />
        (ab) shall not, directly or indirectly, offer, attempt to offer, trade
        or attempt to trade in any item, the dealing of which is prohibited or
        restricted in any manner under the provisions of any applicable law,
        rule, regulation or guideline for the time being in force; or
        <br />
        (ac) shall not create liability for us or cause us to lose (in whole or
        in part) the services of our ISPs or other suppliers.
        <br />
        <br />
        You shall not use any "deep-link", "page-scrape", "robot", "spider" or
        other automatic device, program, algorithm or methodology, or any
        similar or equivalent manual process, to access, acquire, copy or
        monitor any portion of the Website or any Content, or in any way
        reproduce or circumvent the navigational structure or presentation of
        the Website or any Content, to obtain or attempt to obtain any
        materials, documents or information through any means not purposely made
        available through the Website. TK Sports reserves the right to bar any
        such activity.
        <br />
        <br />
        I. You shall not attempt to gain unauthorized access to any portion or
        feature of TK Sports/ Website, or any other systems or networks
        connected to TK Sports World Website or to any TK Sport's server,
        computer, network, or to any of the services offered on or through TK
        Sports World Website, by hacking, password "mining" or any other
        illegitimate means.
        <br />
        II. You shall not probe, scan or test the vulnerability of TK Sports
        TYKA Website or any network connected to TK Sports TYKA Website nor
        breach the security or authentication measures on TK Sports TYKA Website
        or any network connected to TK Sports TYKA Website. You may not reverse
        look-up, trace or seek to trace any information on any other user of or
        visitor to TK Sports TYKA Website, or any other customer of TK Sports,
        including any TK Sport's account not owned by You, to its source, or
        exploit TK Sports TYKA Website or any service or information made
        available or offered by or through TK Sports TYKA Website, in any way
        where the purpose is to reveal any information, including but not
        limited to personal identification or information, other than your own
        information, as provided for by TK Sports TYKA Website.
        <br />
        III. You agree that You will not take any action that imposes an
        unreasonable or disproportionately large load on the infrastructure of
        TK SportsTYKA Website or TK Sport's systems or networks, or any systems
        or networks connected to the TK Sports TYKA Website.
        <br />
        IV. You agree not to use any device, software or routine to interfere or
        attempt to interfere with the proper working of the Website or any
        transaction being conducted on the Website, or with any other person's
        use of the Website.
        <br />
        V. You may not forge headers or otherwise manipulate identifiers in
        order to disguise the origin of any message or transmission You send to
        TK Sports on or through the TYKA Website or any service offered on or
        through the Website. You may not pretend that You are, or that You
        represent, someone else, or impersonate any other individual or entity.
        <br />
        VI. You may not use the Website or any Content for any purpose that is
        unlawful or prohibited by these Terms of Use, or to solicit the
        performance of any illegal activity or other activity which infringes
        the rights of TK Sports or others.
        <br />
        VII. Solely to enable TK Sports to use the information You supply us
        with, so that we are not violating any rights You might have in Your
        Information, you agree to grant us a non-exclusive, worldwide,
        perpetual, irrevocable, royalty-free, sub-licensable (through multiple
        tiers) right to exercise the copyright, publicity, database rights or
        any other rights You have in Your Information, in any media now known or
        not currently known, with respect to Your Information. TK Sports will
        only use Your Information in accordance with this Terms of Use and TK
        Sport's Privacy Policy.
        <br />
        VIII. From time to time, You shall be responsible for providing
        information relating to You or services proposed by You. In this
        connection, You undertake that all such information shall be accurate in
        all respects. You shall not exaggerate or over emphasize the attributes
        of such items or services so as to mislead other Users in any manner.
        <br />
        IX. You shall not engage in advertising to, or solicitation of, other
        users of TK Sports to buy or sell any products or services, including,
        but not limited to, products or services related being displayed on TK
        Sports or related to TK Sports. You may not transmit any chain letters
        or unsolicited commercial or junk email to other users via TK Sports/ TK
        Sports Social site/pages/links. It shall be a violation of these Terms
        of Use to use any information obtained from TK Sports in order to
        harass, abuse, or harm another person, or in order to contact, advertise
        to, solicit, or sell to another person outside of the TK Sports without
        TK Sport's prior explicit consent. In order to protect our users from
        such advertising or solicitation, TK Sports reserves the right to
        restrict the number of messages or emails which a user may send to
        us/other users in any 24-hour period which TK Sports deems appropriate
        in its sole discretion.
        <br />
        X. You understand that TK Sports has the right at all times to disclose
        any information (including the identity of the persons providing
        information or materials on the TK Sports Website) as necessary to
        satisfy any law, regulation or valid governmental request. This may
        include, without limitation, disclosure of the information in connection
        with investigation of alleged illegal activity or solicitation of
        illegal activity or in response to a lawful court order or subpoena. In
        addition, we can (and You hereby expressly authorise us to) disclose any
        information about You to law enforcement or other government officials,
        as we, in our sole discretion, believe necessary or appropriate in
        connection with the investigation and/or resolution of possible crimes,
        especially those that may involve personal injury.
        <br />
        XI. TK Sports reserves the right, but has no obligation, to monitor the
        materials posted on TK Sports website or any Social Network Platforms.
        TK Sports shall have the right to remove or edit any Content that in its
        sole discretion violates, or is alleged to violate, any applicable law
        or either the spirit or letter of this Terms of Use. Notwithstanding
        this right of TK Sports, YOU REMAIN SOLELY RESPONSIBLE FOR THE CONTENT
        OF THE MATERIALS YOU POST ON THE TK SPORTS WEBSITE/ SOCIAL NETWORKS AND
        IN YOUR PRIVATE MESSAGES. Please be advised that such Content posted
        does not necessarily reflect the views of TK Sports. In no event shall
        TK Sports assume or have any responsibility or liability for any Content
        posted or for any claims, damages or losses resulting from use of
        Content and/or appearance of Content on TK Sports. You hereby represent
        and warrant that You have all necessary rights in and to all Content You
        provide and all information it contains and that such Content shall not
        infringe any proprietary or other rights of third parties or contain any
        libellous, tortious, or otherwise unlawful information.
        <br />
        XII. Your correspondence or business dealings with, or participation in
        promotions of, third party advertisers found on or through TK Sports,
        including payment and delivery of related goods or services, and any
        other terms, conditions, warranties or representations associated with
        such dealings, are solely between You and such third party advertiser.
        TK Sports shall not be responsible or liable for any loss or damage of
        any sort incurred as the result of any such dealings or as the result of
        the presence of such third party advertisers on TK Sports.
        <br />
        XIII. It is possible that other users (including unauthorized users or
        “hackers”) may post or transmit offensive or obscene materials on TK
        Sports and that You may be involuntarily exposed to such offensive and
        obscene materials. It also is possible for others to obtain personal
        information about You on the public forum due to your use of TK Sports,
        and that the recipient may use such information to harass or injure You.
        TK Sports does not approve of such unauthorized uses but by using the TK
        Sports Website You acknowledge and agree that TK Sports is not
        responsible for the use of any personal information that You publicly
        disclose or share with others on TK Sports. Please carefully select the
        type of information that You publicly disclose or share with others on
        TK Sports, or from TK Sports on other social platforms (eg, but not
        limited to Facebook/Twitter etc).
        <br />
        XIV. TK Sports shall have all the rights to take necessary action and
        claim damages that may occur due to your involvement/participation in
        any way on your own or through group/s of People, intentionally or
        unintentionally in DoS/DDoS (Distributed Denial of Services).
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        You shall not attempt unauthorized access, disrupt website services,
        interfere with operations, or use the website for unlawful purposes. TK
        Sports reserves the right to take appropriate legal action for
        violations.
      </p>

      {/* Section 6 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">
        Contents Posted on Site
      </h3>
      <p className="mb-4 text-black text-md">
        All text, graphics, user interfaces, visual interfaces, photographs,
        trademarks, logos, sounds, music, artwork, and computer code
        (collectively, "Content"), including but not limited to the design,
        structure, selection, coordination, expression, "look and feel," and
        arrangement of such Content, contained on TK Sports is owned,
        controlled, or licensed by or to TK Sports, and is protected by trade
        dress, copyright, patent and trademark laws, and various other
        intellectual property rights and unfair competition laws.
        <br />
        <br />
        Except as expressly provided in these Terms of Use, no part of TK Sports
        and no Content may be copied, reproduced, republished, uploaded, posted,
        publicly displayed, encoded, translated, transmitted, or distributed in
        any way (including "mirroring") to any other computer, server, website,
        or other medium for publication or distribution or for any commercial
        enterprise, without TK Sports' express prior written consent.
        <br />
        <br />
        You may use information on TK Sports products and services purposely
        made available by TK Sports for downloading from the Site, provided that
        you:
        <br />
        (1) Do not remove any proprietary notice language in all copies of such
        documents; <br />
        (2) Use such information only for your personal, non-commercial
        informational purposes and do not copy or post such information on any
        networked computer or broadcast it in any media; <br />
        (3) Make no modifications to any such information; <br />
        (4) Do not make any additional representations or warranties relating to
        such documents.
        <br />
        <br />
        You shall be responsible for any notes, messages, e-mails, billboard
        postings, photos, drawings, profiles, opinions, ideas, images, videos,
        audio files, or other materials or information posted or transmitted to
        the Sites/Social media platforms (collectively, "Content"). Such Content
        will become the property of TK Sports and you grant TK Sports the
        worldwide, perpetual, and transferable rights in such Content.
        <br />
        <br />
        TK Sports shall be entitled to, consistent with our Privacy Policy, use
        the Content or any of its elements for any type of use forever,
        including but not limited to promotional and advertising purposes and in
        any media whether now known or hereafter devised, including the creation
        of derivative works that may include Content you provide. You agree that
        any Content you post may be used by <strong>tyka.com</strong>,
        consistent with our Privacy Policy and Rules of Conduct on Site as
        mentioned herein, and you are not entitled to any payment or other
        compensation for such use.
      </p>

      {/* Section 7 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Other Businesses</h3>
      <p className="mb-4 mt-6 text-black text-md">
        TK Sports does not take responsibility or liability for the actions,
        products, content and services on TK Sports website, which are linked to
        Affiliates and / or third party websites using TK Sports APIs or
        otherwise. In addition, TK Sports may provide links to the third party
        websites of affiliated companies and certain other businesses for which,
        TK Sports assumes no responsibility for examining or evaluating the
        products and services offered by them, and TK Sports does not warrant
        the offerings of, any of these businesses or individuals or the content
        of such third party website(s). TK Sports does not in any way endorse
        any third party website(s) or content thereof.
      </p>

      {/* Section 8 */}
      <h3 className="text-2xl font-semibold mb-2 mt-8">Links</h3>
      <p className="mb-4 mt-6 text-black text-md">
        TK Sports don't endorse links to this Website however, TK Sports can
        welcome links from its sub brands and sister concerns/group companies on
        the website. You can't establish a hypertext link to TK Sports website.
        You must not use on your site or in any other manner any trademarks,
        service marks or any other materials appearing on the TK Sports,
        including any logos or characters, without the express written consent
        of TK Sports and the owner of the mark or materials. You must not frame
        or otherwise incorporate into another third party website or present in
        conjunction with or juxtaposed against such a website any of the content
        or other materials on the TK Sports TYKA website without TK Sports prior
        written consent.
      </p>
      {/* Privacy */}
      <h3 className="text-xl font-semibold mb-2">Privacy</h3>
      <p className="mb-4">
        We view protection of Your privacy as a very important principle. We
        understand clearly that you and your personal identification information
        is one of our most important assets. We store and process Your Personal
        Identifiable Information on computers that may be protected by physical
        as well as reasonable technological security measures and procedures in
        accordance with Information Technology Act 2000 and rules there under.
        If you object to your Information being transferred or used in this way
        please do not use TK Sports Website.
      </p>

      {/* Mandatory Declaration */}
      <h3 className="text-xl font-semibold mb-2">Mandatory Declaration</h3>
      <ol className="list-decimal list-inside mb-4">
        <li>
          You hereby declare that You have provided all necessary Legal Details
          for the shipment of the product to the destination specified by You in
          the Order.
        </li>
        <li>
          You further declare that the Product will be acquired for personal use
          of the Consignee and/or Buyer. The Product will not be sold, resold,
          bartered or in any way disposed for profit.
        </li>
      </ol>

      {/* Disclaimer of Warranties and Liability */}
      <h3 className="text-xl font-semibold mb-2">
        Disclaimer of Warranties and Liability
      </h3>
      <p className="mb-2">
        This website, all the materials and products (including but not limited
        to software) and services, included on or otherwise made available to
        You through this site are provided on TK Sports on "as is" and "as
        available" basis without any representation or warranties, express or
        implied except otherwise specified in writing. Without prejudice to the
        forgoing paragraph, TK Sports does not warrant that:
      </p>
      <ol className="list-roman list-inside mb-4">
        <li>
          This website will be constantly available, or available at all; or
        </li>
        <li>
          The information on this website is complete, true, accurate or
          non-misleading.
        </li>
        <li>
          TK Sports will not be liable to You in any way or in relation to the
          contents of, or use of, or otherwise in connection with, TK Sports
          website.
        </li>
        <li>
          TK Sports does not warrant that this site; information, Content,
          materials, product (including software) or services included on or
          otherwise made available to You through TK Sports website; their
          servers; or electronic communication sent from TK Sports are free of
          viruses or other harmful components;
        </li>
        <li>
          Nothing on TK Sports constitutes, or is meant to constitute, advice of
          any kind;
        </li>
        <li>
          All the products sold on TK Sports are governed by different state
          laws and if TK Sports is unable to deliver such products due to
          implications of different state laws, TK Sports will return or will
          give credit for the amount received by TK Sports from the sale of such
          product, that could not be delivered to You;
        </li>
        <li>
          You will be required to enter a valid phone number while placing an
          order on TK Sports. By registering your phone number with us, You
          consent to be contacted by TK Sports via phone calls and / or SMS
          notifications, in case of any order or shipment or delivery related
          updates. TK Sports will not use your personal information to initiate
          any promotional phone calls or SMS'.
        </li>
      </ol>

      {/* Services - Payment */}
      <h3 className="text-xl font-semibold mb-2">Services</h3>
      <h3 className="text-lg font-semibold mb-1">Payment</h3>
      <ol className="list-decimal list-inside mb-4">
        <li>
          While availing any of the payment method/s offered at TK Sports, TK
          Sports will not be responsible or assume any liability, whatsoever in
          respect of any loss or damage arising directly or indirectly to You
          due to:
          <ol className="list-roman list-inside ml-4">
            <li>Lack of authorization for any transaction/s; or</li>
            <li>
              Exceeding the preset limit mutually agreed by You and between your
              "Bank/s"; or
            </li>
            <li>Any payment issues arising out of the transaction; or</li>
            <li>Decline of transaction for any other reason/s.</li>
          </ol>
        </li>
        <li>
          All payments made against the purchases/services on TK Sports TYKA
          website by You shall be compulsorily in Indian Rupees acceptable by
          the Union of India. TK Sports does not accept any other form of
          currency with respect to the purchases made on TK Sports.
        </li>
      </ol>

      {/* Breach */}
      <h3 className="text-xl font-semibold mb-2">Breach</h3>
      <p className="mb-2">
        Without limiting other remedies, TK Sports may limit your activity,
        immediately remove your information, warn other Users of your actions,
        immediately temporarily/indefinitely suspend or terminate or block your
        membership, and/or refuse to provide You with access to the TK Sports
        TYKA website in the event, but not limited to:
      </p>
      <ol className="list-roman list-inside mb-4">
        <li>
          If You breach the Terms of Use or Privacy Policy or other rules and
          policies, if any;
        </li>
        <li>
          If TK Sports is unable to verify or authenticate any information you
          provide; or
        </li>
        <li>
          If it is believed that your actions may cause legal liability for you,
          other Users or TK Sports. TK Sports may at any time at its sole
          discretion reinstate suspended Users. A User that has been suspended
          or blocked may not register or attempt to register with TK Sports or
          use TK Sports Website in any manner whatsoever until such time that
          such User is reinstated by TK Sports.
        </li>
      </ol>
      <p className="mb-4">
        Notwithstanding the foregoing, if you breach the Terms of Use or Privacy
        Policy or other rules and policies, TK Sports reserves the right to
        recover any amounts due and owing by you to TK Sports or to take strict
        legal action including but not limited to a referral to the appropriate
        police or other authorities for initiating criminal or other proceedings
        against you.
      </p>

      {/* Indemnity */}
      <h3 className="text-xl font-semibold mb-2">Indemnity</h3>
      <p className="mb-4">
        You shall indemnify and hold harmless TK Sports, its owner, licensee,
        affiliates, subsidiaries, group companies (as applicable) and their
        respective officers, directors, agents, and employees, from any claim or
        demand, or actions including reasonable attorneys' fees, made by any
        third party or penalty imposed due to or arising out of your breach of
        this Terms of Use, Privacy Policy and other Policies, or your violation
        of any law, rules or regulations or the rights of a third party.
      </p>

      {/* Applicable Law */}
      <h3 className="text-xl font-semibold mb-2">Applicable Law</h3>
      <p className="mb-4">
        This Agreement shall be governed by and interpreted and construed in
        accordance with the laws of India. The courts at Jalandhar, Punjab,
        India shall alone have exclusive jurisdiction in any proceedings arising
        out of this agreement.
      </p>
      {/* Jurisdiction */}
      <h3 className="text-lg font-semibold">
        Jurisdictional Issues / Sale in India Only
      </h3>
      <p className="mb-4">
        Unless otherwise specified, the material on TK Sports TYKA website is
        presented solely for the purpose of sale in India. TK Sports makes no
        representation that materials in TK Sports are appropriate or available
        for use in other locations/Countries other than India. Those who choose
        to access this site from other locations/Countries other than India do
        so on their own initiative and TK Sports is not responsible for supply
        of goods/refund for the goods ordered from other locations/Countries
        other than India, compliance with local laws, if and to the extent local
        laws are applicable.
      </p>

      {/* Trademark */}
      <h3 className="text-lg font-semibold">
        Trademark, Copyright and Restriction
      </h3>
      <p className="mb-4">
        This site is controlled and operated by TK Sports Pvt Ltd. All material
        on this site, including logo's, images, illustrations, audio clips, and
        video clips, are protected by copyrights, trademarks, and other
        intellectual property rights that are owned and controlled by TK Sports
        or by other parties that have licensed their material to us. Material on
        TK Sports web site owned, operated, licensed or controlled by TK Sports
        is solely for your personal, non-commercial use. You must not copy,
        reproduce, republish, upload, post, transmit or distribute such material
        in any way, including by e-mail or other electronic means and whether
        directly or indirectly and you must not assist any other person to do
        so. Without the prior written consent of the owner, modification of the
        materials, use of the materials on any other web site or networked
        computer environment or use of the materials for any purpose other than
        personal, non-commercial use is a violation of the copyrights,
        trademarks and other proprietary rights, and is prohibited. Any use for
        which you receive any remuneration, whether in money or otherwise, is a
        commercial use for the purposes of this clause.
      </p>

      {/* Copyright Complaint */}
      <h3 className="text-lg font-semibold">Copyright Complaint</h3>
      <p className="mb-4">
        We at TK Sports respect the Intellectual property rights of others. In
        case you feel that your work/posts/comments/images has been copied in a
        way that constitutes copyright infringement, You can write to us at{" "}
        <span className="text-blue-600">info@tyka.com</span>
      </p>

      {/* Kit Builder */}
      <h3 className="text-lg font-semibold">
        Kit Builder / Custom Designing Tool
      </h3>
      <p className="mb-4">
        We have introduced Kit Builder/ Designing Tool after taking into
        consideration that Customers like to give input on their Design Idea's.
        To cut down communication time Kit Builder/ Designing Tool will be
        really helpful. However, Any design idea submitted/ designed/ made/
        sketched/ thought off/ printed will be considered and will be Property
        of TK Sports India and Customer will have no right over any design
        submitted/ designed/ made/ sketched/ thought off/ printed from the
        Website tyka.com including but not limited to Copyright and Intellectual
        Property Rights since the platform is provided by TK Sports India.
      </p>
      <p className="mb-4">
        However, all the logo/ logo's provided by any person/ customer/
        association/ teams/ clubs etc will be considered or deemed considered to
        be the rightful owner of Logo/ Logo's and the rightful property of the
        customer/ association/ teams/ clubs etc. TK Sports will be not held
        liable of any Breach of Copyright, Trademark and Intellectual Property
        right of any Logo/ Logo's submitted by any person/ customer/
        association/ teams/ clubs etc which is not legally owned/ created/ made/
        sketched by any person/ customer/ association/ teams/ clubs etc. on our
        Kit Builder/ Custom Designing Tool.
      </p>
      <p className="mb-4">
        TK Sports India on its website tyka.com and under its Kit Builder/
        Designing Tool will not accept any request or process any order where,
        We firmly believe that the Logo/ Logo's are not owned by person/
        customer/ association/ teams/ clubs etc. We will not only inform the
        concerned person/ customer/ association/ teams/ clubs etc but we will
        also initiate Legal action for misusing our website and our Kit Builder/
        Designing Tool and to harm our image by doing such Illegal activity.
      </p>

      {/* Risk of Loss */}
      <h3 className="text-lg font-semibold">Risk of Loss</h3>
      <p className="mb-4">
        All items purchased from tyka.com are made pursuant to a shipment
        contract. This means that the risk of loss and title for such items pass
        to you upon our delivery to the carrier.
      </p>

      {/* Product Description */}
      <h3 className="text-lg font-semibold">Product Description</h3>
      <p className="mb-4">
        tyka.com tries to be as accurate as possible. However, tyka.com does not
        warrant that product description or other content of this site is
        accurate, complete, reliable, current, or error-free.
      </p>

      {/* Pricing */}
      <h3 className="text-lg font-semibold">Pricing / Typographical Error</h3>
      <p className="mb-4">
        If tyka.com comes across any difference in pricing resulting from
        typographic errors write pricing or product information, tyka.com shall
        have the right to rectify the same or cancel the order(s) and refund the
        money, if any, collected from the customer within 05 business days of
        such corrective action taken. The mode of refund will be the same as at
        the time of placing the order. Cash on Delivery order refunds will be
        done by cheque.
      </p>

      {/* 1 Day Replacement */}
      <h3 className="text-lg font-semibold">1 Day Replacement Guarantee</h3>
      <ol className="list-decimal list-inside mb-2">
        <li>
          TK Sports offers you REPLACEMENT WITHIN 1 DAY FROM THE DATE OF
          DELIVERY ON the product/products ordered on TK Sports TYKA website i.e
          within 1 day from the date of delivery of the product/s, if any defect
          is found, then the buyer of the product/products can ask for
          replacement of the product/products subject to the following terms and
          conditions:
          <ol className="list-roman list-inside ml-4">
            <li>
              Notify us of any defects within 24 hours from the date of delivery
              and the same product/products will be replaced in return of the
              defective product/products.
            </li>
            <li>
              Notify us of any other returns the product/products and/or within
              24 hours from the date of delivery and the same product/products
              will be replaced in return of the product/products.
            </li>
            <li>
              Replacement can be for the entire product/products or part/parts
              of the product subject to availability of the same with TK Sports
              only.
            </li>
          </ol>
        </li>
        <li>
          Following products shall not be eligible for return or replacement:
          <ol className="list-roman list-inside ml-4">
            <li>Damages due to misuse of product;</li>
            <li>Incidental damage due to malfunctioning of product;</li>
            <li>Any consumable item which has been used;</li>
            <li>Products with tampered or missing serial/UPC numbers;</li>
            <li>
              Any damage/defect which are not covered under the manufacturer's
              warranty;
            </li>
            <li>
              Any product that is returned without all original packaging and
              accessories, including the box, manufacturer's packaging if any,
              and all other items originally included with the product/s
              delivered;
            </li>
          </ol>
        </li>
      </ol>
      <p className="mb-4">
        Disclaimer: "ANY DECISION ON 1 DAY REPLACEMENT GUARANTEE ON THE
        PRODUCT/PRODUCTS SOLD ON TYKA.COM is at the sole discretion of Seller TK
        Sports and decision of TK Sports AS Seller shall be final and binding.
        Seller TK Sports reserves the right to withdraw and/or alter from 1 DAY
        REPLACEMENT GUARANTEE at any time without giving any intimation of
        whatsoever nature."
      </p>

      {/* Cancellation */}
      <h3 className="text-lg font-semibold">Cancellation of Order</h3>
      <p className="mb-4">
        tyka.com reserves the right to cancel any order without any explanation
        for doing so, under situation where tyka.com is not able to meet the
        requirement of the order placed or order so placed/cancelled does not
        comply with the tyka.com policy or order has invalid address/incorrect
        information or for any other reason. However, tyka.com will ensure that
        any communication of cancellation of an order, so cancelled, is
        intimated within appropriate time to the concerned person and any
        applicable refund, will be made in reasonable time.
      </p>

      {/* Promotions */}
      <h3 className="text-lg font-semibold">
        Terms & Conditions For Promotions / Offers / End of Season Sale
      </h3>
      <ol className="list-decimal list-inside mb-4">
        <li>
          Sale/discounts apply to selected items only. Although there are/will
          be many products on SALE, there might be some exclusion.
        </li>
        <li>
          The End of Season Sale runs till stock lasts. Sale up to 50% off does
          not imply that all products are on discount.
        </li>
        <li>No two offers can be clubbed together.</li>
        <li>
          Due to technical issues, typographical errors or information received
          from our suppliers and service providers, prices of the products shown
          on the Site may vary during the order process. If you come across any
          errors in pricing or billing, we request you to contact us within 24
          hours of receiving your order so that we may provide a remedy for the
          same.
        </li>
        <li>All offers are non-transferable and have no cash value.</li>
        <li>
          tyka.com reserves the right to extend/
          terminate/amend/add/remove/modify (in whole or part) the offers/sale,
          without further information at any point of time and tyka.com’s
          decision in this regard shall be final and requires no intimation to
          the customer of any sort.
        </li>
        <li>
          In case of any query pertaining to the schemes, please email customer
          care at coordinator@tyka.com or call @ +91-181-5006935.
        </li>
      </ol>

      {/* Limitation of Liability */}
      <h3 className="text-lg font-semibold">Limitation of Liability</h3>
      <p className="mb-4">
        IN NO EVENT SHALL TYKA.COM BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
        INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND IN CONNECTION WITH THIS
        AGREEMENT, EVEN IF TYKA.COM HAS BEEN INFORMED IN ADVANCE OF THE
        POSSIBILITY OF SUCH DAMAGES.
      </p>

      {/* Contact */}
      <h3 className="text-lg font-semibold">Our Contact</h3>
      <p className="mb-4">
        Please send any questions or comments (including all inquiries unrelated
        to copyright infringement) regarding this Site to info@tyka.com
      </p>
    </div>
  );
}
